exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".business__layout__section{grid-template-columns:185px calc(100% - 185px)}@media handheld,only screen and (max-width:768px){.business__layout__section{grid-template-columns:100%!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c1b6a698","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/franchise_v4/rank/components/gainsFranchiseeBa.vue
// module id = w+CN
// module chunks = 0